import './style/index.scss';

import HomePage from './pages/HomePage/HomePage';

function App() {
  return (
    <div className="app-container">
      <HomePage />
    </div>
  );
}

export default App;
